// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
// 地图
import AMap from 'vue-amap'

// 导入样式文件
import '@/assets/css/index.less'
// 注册element-ui组件
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import Video from 'video.js'
import 'video.js/dist/video-js.css'

Vue.use(AMap)
// 初始化vue-amap
AMap.initAMapApiLoader({
  // 高德key
  key: '你的key',
  // 插件集合 （插件按需引入）
  plugin: [
    'AMap.Autocomplete' // 输入提示插件
  ]
})

Vue.use(ElementUI)

Vue.prototype.$fetch = fetch
Vue.prototype.webType = 1 // 0 派加 1 卡百利
Vue.prototype.$baseImgUrl = 'https://cdn-oss.kabel.work/website/'// 图片公共路径
Vue.prototype.$baseImgUrlTow = 'https://cdn-oss.kabel.work/scheme/'// 图片公共路径



Vue.config.productionTip = false
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js